import { apiRequest } from './index';

export const generateLeaveBalanceReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/leave-balance-report',
        {
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateBirthdayReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/birthday-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateUndertimeReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/undertime-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateTardinessReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/tardiness-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateHabitualTardinessReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/habitual-tardiness-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateAwolReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/awol-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateAbsencesReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/absences-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generatePagIbigReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/pagibig-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generatePhicReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/phic-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const generateSSSReportRequest = ( data, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(
        '/reports/sss-report',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}
